import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ESTILO_BOTON_LISTAR_NUEVO, ESTILO_BOTON_MODAL_ACEPTAR } from "../../../utils/const/estilos-const";
import ModalConfirmar from "../../../components/modal-confirmar";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import sinAccesoCard from "../../../components/sin-acceso-card";
import { Upload, Download } from "lucide-react";
import { sharedMensajeConfirmacion, sharedNextPage, sharedExportarLink } from "../../../utils/shared-functions";
import { SELECT_HABILITADO_DESHABILITADO } from "../../../utils/const/const-select-habilitado-deshabilitado";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { COLOR_VERDE_MAIN } from "../../../utils/const/colors-const";
import ProcessingDialog from "../../../components/processing-dialog";
import ToastComponent from "../../../components/toast-component";
import { crearClientesDesdeExcel, deshabilitarCliente, habilitarCliente, obtenerListaCliente } from "../../../api/api-cliente";
import readXlsxFile from "read-excel-file";
import { obtenerListaConfiguracionCliente } from "../../../api/api-configuracion-cliente";
import { INDEX_COLUMNAS_ASIGNACION, NOMBRE_COLUMNAS_ASIGNACION } from "../configuracion-cliente/columnas";
import { STRING_ID_TIPO_USUARIO_WEB, STRING_SUPER_ADMIN, STRING_ID_ROL_USUARIO_WEB } from "../../../utils/const/string-const";
import { obtenerPermisoRolUsuarioWeb } from "../../../api/api-permiso-rol-usuario-web";
import { PAGE_ID } from "../../usuarios/gestionar-rol-usuario-web/pages-const";

let $ = window.$;

export default function ListarClientePage
  () {
  const idTipoUsuarioWeb = localStorage.getItem(STRING_ID_TIPO_USUARIO_WEB);
  const { t } = useTranslation();
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  // const [listaElementos, setListaElementos] = useState([]);
  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] = useState(false);

  const [modalConfirmarImportarVisible, setModalConfirmarImportarVisible] = useState(false);

  const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);

  const [rowsData, setRowsData] = useState([]);
  const [btnBuscar, setBtnBuscar] = useState(false);
  const [btnNuevo, setBtnNuevo] = useState(false);
  const [btnModificar, setBtnModificar] = useState(false);
  const [btnDeshabilitar, setBtnDeshabilitar] = useState(false);
  const [btnHabilitar, setBtnHabilitar] = useState(false);
  const [btnImportar, setBtnImportar] = useState(false);
  const [btnExportar, setBtnExportar] = useState(false);

  const [configuracionCliente, setConfiguracionCliente] = useState(null);
  const [listaClientesParaImportar, setListaClientesParaImportar] = useState([]);

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    let tieneAcceso = false;
    try {
      let objEnviar = {};
      objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : null;
      if (idTipoUsuarioWeb === STRING_SUPER_ADMIN) {
        tieneAcceso = true;
        setBtnBuscar(true);
        setBtnNuevo(true);
        setBtnModificar(true);
        setBtnDeshabilitar(true);
        setBtnHabilitar(true);
        setBtnImportar(true);
        setBtnExportar(true);
      }
      if (idTipoUsuarioWeb !== STRING_SUPER_ADMIN) {
        const idRolUsuarioWeb = localStorage.getItem(STRING_ID_ROL_USUARIO_WEB);
        objEnviar.idRolUsuarioWeb = idRolUsuarioWeb;
        const response = await obtenerPermisoRolUsuarioWeb(objEnviar);
        // console.log('response obtenerPermisoRolUsuarioWeb');
        // console.log(response);
        if (response.error === false && response.data !== undefined) {
          const permisos = JSON.parse(response.data.permisos);
          // console.log('permisos');
          // console.log(permisos);
          if (Array.isArray(permisos) && permisos.length > 0) {
            const manage = permisos.find(p => p.id === 2);
            // console.log('manageClient');
            // console.log(manageClient);
            if (manage !== undefined && manage !== null) {
              // console.log('permisosPage.checked');
              // console.log(permisosPage.checked);
              const permisosPage = manage.subMenu.find(p => p.value === PAGE_ID.CLIENTES);
              // console.log('permisosPage');
              // console.log(permisosPage);
              tieneAcceso = permisosPage.checked;
              if (tieneAcceso === false) {
                return;
              }
              const permisoBtnBuscar = permisosPage.acciones.find(a => a.value === 'btn_buscar');
              const permisoBtnNuevo = permisosPage.acciones.find(a => a.value === 'btn_nuevo');
              const permisoBtnModificar = permisosPage.acciones.find(a => a.value === 'btn_modificar');
              const permisoBtnDeshabilitar = permisosPage.acciones.find(a => a.value === 'btn_deshabilitar');
              const permisoBtnHabilitar = permisosPage.acciones.find(a => a.value === 'btn_habilitar');
              const permisoBtnImportar = permisosPage.acciones.find(a => a.value === 'btn_importar');
              const permisoBtnExportar = permisosPage.acciones.find(a => a.value === 'btn_exportar');
              setBtnBuscar(permisoBtnBuscar?.checked);
              setBtnNuevo(permisoBtnNuevo?.checked);
              setBtnModificar(permisoBtnModificar?.checked);
              setBtnDeshabilitar(permisoBtnDeshabilitar?.checked);
              setBtnHabilitar(permisoBtnHabilitar?.checked);
              setBtnImportar(permisoBtnImportar?.checked);
              setBtnExportar(permisoBtnExportar?.checked);
            }
          }
        }
      }
      if (tieneAcceso === true) {
        let lista = [];

        lista = await obtenerListaCliente(objEnviar, false, t);
        // console.log('lista:');
        // console.log(lista);
        setRowsData(lista);

        const obtenerconfiguracionCliente = await obtenerListaConfiguracionCliente({}, false, t);
        // console.log('obtenerconfiguracionCliente:');
        // console.log(obtenerconfiguracionCliente);
        if (Array.isArray(obtenerconfiguracionCliente) && obtenerconfiguracionCliente.length > 0) {
          setConfiguracionCliente(JSON.parse(obtenerconfiguracionCliente[0].configuracion));
        }
      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
      setTieneAccesoAlModulo(tieneAcceso);
    }
  };

  useEffect(() => {
    // While loading, the grid mount point is not rendered (cargandoCard only),
    // so we must tie this effect to cargandoPage as well. Otherwise rowsData updates
    // first, effect runs with no #gridContainer, then loading ends and rowsData does
    // not change → the grid never initializes.
    if (cargandoPage) {
      return;
    }

    const timer = setTimeout(() => {
      const gridElement = $("#gridContainer");
      if (gridElement.length) {
        try {
          const gridInstance = gridElement.dxDataGrid("instance");
          if (gridInstance) {
            gridInstance.option("dataSource", rowsData);
          } else {
            inicializarGrid();
          }
        } catch (e) {
          inicializarGrid();
        }
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [rowsData, cargandoPage]);

  const inicializarGrid = () => {
    try {
      const gridElement = $("#gridContainer");

      // Check if element exists
      if (!gridElement.length) {
        // console.warn("Grid container element not found");
        return;
      }

      // Initialize the grid
      gridElement.dxDataGrid({
        dataSource: rowsData,
        paging: {
          pageSize: 20,
        },
        pager: {
          showPageSizeSelector: true,
          allowedPageSizes: [50, 100, 150, 200],
        },
        remoteOperations: false,
        groupPanel: { visible: true },
        grouping: {
          autoExpandAll: false,
        },
        allowColumnReordering: true,
        rowAlternationEnabled: true,
        showBorders: true,
        columnAutoWidth: true,
        filterRow: {
          visible: true,
          applyFilter: "auto",
        },
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: t("grilla_placeholderbuscar"),
        },
        export: {
          enabled: true,
        },
        headerFilter: {
          visible: true,
        },
        columns: [
          {
            dataField: "acciones",
            caption: t("column_acciones"),
            width: 200,
            allowFiltering: false,
            allowSorting: false,
            cellTemplate: function (container, options) {
              // console.log("cellTemplate acciones");
              // console.log('options', options);
              // console.log('options.data', options.data);
              const buttonContainer = $("<div>").addClass("flex gap-2");
              if (btnModificar === true) {
                // Edit button
                $("<button>")
                  .addClass(
                    "px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-sm"
                  )
                  .text(t("column_modificar"))
                  .on("click", function () {
                    modificarElementoSelected(options.data);
                  })
                  .appendTo(buttonContainer);
              }

              if (btnDeshabilitar === true) {
                if (options.data.habilitado === 1) {
                  $("<button>")
                    .addClass(
                      "px-3 py-1 bg-red-500 hover:bg-red-600 text-white rounded text-sm"
                    )
                    .text(t("column_deshabilitar"))
                    .on("click", function () {
                      cambiarEstadoDeshabilitar(options.data);
                    })
                    .appendTo(buttonContainer);
                }
              }
              if (btnHabilitar === true) {
                if (options.data.habilitado === 0) {
                  $("<button>")
                    .addClass(
                      `px-3 py-1 bg-[${COLOR_VERDE_MAIN}] hover:bg-[#006600] text-white rounded text-sm`
                    )
                    .text(t("column_habilitar"))
                    .on("click", function () {
                      cambiarEstadoHabilitar(options.data);
                    })
                    .appendTo(buttonContainer);
                }
              }

              buttonContainer.appendTo(container);
            },
          },
          {
            dataField: "id",
            caption: "ID",
            visible: false,
          },
          {
            dataField: "codigo",
            caption: t("column_codigo"),
            visible: true,
          },
          {
            dataField: "descripcion",
            caption: t("column_descripcion"),
            visible: true,
          },
          {
            dataField: "nota",
            caption: t("column_nota"),
            width: 150,
          },
          {
            dataField: "latitud",
            caption: t("column_latitud"),
            width: 150,
          },
          {
            dataField: "longitud",
            caption: t("column_longitud"),
            width: 150,
          },
          {
            dataField: "tipoCliente",
            caption: t("column_tipo_cliente"),
            width: 200,
          },
          {
            dataField: "fechaProceso",
            caption: t("column_fechaProceso"),
            width: 200,
          },
          {
            dataField: "habilitadoLabel",
            caption: t("column_estado"),
            width: 200,
          }
        ],
      });
    } catch (err) {
      console.error("Error initializing grid:", err);
    }
  };

  const modificarElementoSelected = (data) => {
    try {
      // console.log("modificarElementoSelected");
      // console.log(data);
      if (data.acciones !== undefined) {
        delete data.acciones;
      }
      let obj = {};
      obj.titulo = t("label_modificar_cliente");
      obj.params = data;
      // console.log('obj');
      // console.log(obj);
      sharedNextPage("cliente", obj, history);
    } catch (err) {
      console.log("modificarElementoSelected err");
      console.log(err);
    }
  };

  const cambiarEstadoDeshabilitar = async (data) => {
    try {
      // console.log("cambiarEstadoDeshabilitar");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstadoDeshabilitar err");
      console.log(err);
    }
  };

  const cambiarEstadoHabilitar = async (data) => {
    try {
      // console.log("cambiarEstadoHabilitar");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarHabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstadoHabilitar err");
      console.log(err);
    }
  };

  const handleNuevoClick = () => {
    // console.log("handleNuevoClick");
    let obj = {};
    let data = {};
    data.id = 0;
    data.codigo = "";
    data.descripcion = "";
    data.nota = "";
    data.latitud = "";
    data.longitud = "";
    data.idGrupoCliente = null;
    data.idPais = null;
    data.idCiudad = null;
    data.idGeocerca = null;
    data.telefonoCliente = [];
    data.emailCliente = [];
    data.distanciaAlerta = 10;
    obj.titulo = t("label_crear_cliente");
    obj.params = data;
    sharedNextPage("cliente", obj, history);
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handleConfirmModalDeshabilitar = async () => {
    setModalConfirmarDeshabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    setProcessingVisible(true);
    if (elementoSelected.id !== 0) {
      // console.log('crear correo');
      const response = await deshabilitarCliente(objEnviar);
      setProcessingVisible(false);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        showToast(t("alert_se_deshabilito_correctamente"));
        reset();
      }
      if (response.error === true) {
        showToast(response.message, "error", 3000);
      }
    }
  };

  const handleConfirmHabilitarModal = async () => {
    setModalConfirmarHabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      // console.log('crear correo');
      const response = await habilitarCliente(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        showToast(t("alert_se_habilito_correctamente"), "success", 3000);
        reset();
      }
      if (response.error === true) {
        showToast(response.message, "error", 3000);
      }
    }
  };

  const onClickImportar = () => {
    const input = document.getElementById('importar_clientes');
    input.click();
    // setExcelValido(false);
    // setSelectedMappings({});
    // setAvailableOptions([]);
  };

  const handleFileChange = async (event) => {
    try {
      const file = event.target.files[0];
      if (!file) {
        return;
      }

      // Check if file is xlsx
      if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
        showToast('El archivo debe ser un archivo Excel (.xlsx o .xls)', "error", 3000);
        // setExcelValido(false);
        return;
      }

      // console.log('configuracionCliente:');
      // console.log(configuracionCliente);

      let codigoCliente = INDEX_COLUMNAS_ASIGNACION.CODIGO_CLIENTE;
      let nombreCliente = INDEX_COLUMNAS_ASIGNACION.NOMBRE_CLIENTE;
      let latitudCliente = INDEX_COLUMNAS_ASIGNACION.LATITUD_CLIENTE;
      let longitudCliente = INDEX_COLUMNAS_ASIGNACION.LONGITUD_CLIENTE;
      let direccionCliente = INDEX_COLUMNAS_ASIGNACION.DIRECCION_CLIENTE;
      let telefonoCliente = INDEX_COLUMNAS_ASIGNACION.TELEFONO_CLIENTE;

      if (configuracionCliente !== null) {
        if (configuracionCliente[NOMBRE_COLUMNAS_ASIGNACION.CODIGO_CLIENTE]?.value !== undefined) {
          codigoCliente = configuracionCliente[NOMBRE_COLUMNAS_ASIGNACION.CODIGO_CLIENTE]?.value;
        }
        if (configuracionCliente[NOMBRE_COLUMNAS_ASIGNACION.NOMBRE_CLIENTE]?.value !== undefined) {
          nombreCliente = configuracionCliente[NOMBRE_COLUMNAS_ASIGNACION.NOMBRE_CLIENTE]?.value;
        }
        if (configuracionCliente[NOMBRE_COLUMNAS_ASIGNACION.LATITUD_CLIENTE]?.value !== undefined) {
          latitudCliente = configuracionCliente[NOMBRE_COLUMNAS_ASIGNACION.LATITUD_CLIENTE]?.value;
        }
        if (configuracionCliente[NOMBRE_COLUMNAS_ASIGNACION.LONGITUD_CLIENTE]?.value !== undefined) {
          longitudCliente = configuracionCliente[NOMBRE_COLUMNAS_ASIGNACION.LONGITUD_CLIENTE]?.value;
        }
        if (configuracionCliente[NOMBRE_COLUMNAS_ASIGNACION.DIRECCION_CLIENTE]?.value !== undefined) {
          direccionCliente = configuracionCliente[NOMBRE_COLUMNAS_ASIGNACION.DIRECCION_CLIENTE]?.value;
        }
        if (configuracionCliente[NOMBRE_COLUMNAS_ASIGNACION.TELEFONO_CLIENTE]?.value !== undefined) {
          telefonoCliente = configuracionCliente[NOMBRE_COLUMNAS_ASIGNACION.TELEFONO_CLIENTE]?.value;
        }
      }

      // Read the Excel file
      const rows = await readXlsxFile(file);

      // console.log('Excel file content:');
      // console.log(rows);

      const bodyRows = Array.isArray(rows) ? rows.slice(1) : [];
      // console.log('bodyRows:');
      // console.log(bodyRows);
      // let objEnviar = {};
      let listaClientes = [];
      for (let i = 0; i < bodyRows.length; i++) {
        let obj = {};
        obj.codigo = bodyRows[i][codigoCliente];
        obj.nombre = bodyRows[i][nombreCliente];
        obj.latitud = bodyRows[i][latitudCliente];
        obj.longitud = bodyRows[i][longitudCliente];
        obj.direccion = bodyRows[i][direccionCliente];
        obj.telefono = bodyRows[i][telefonoCliente];
        listaClientes.push(obj);
      }
      // console.log('listaClientes:');
      // console.log(listaClientes);
      if (listaClientes.length > 0) {
        setListaClientesParaImportar(listaClientes);
        setModalConfirmarImportarVisible(true);
      }
    } catch (err) {
      console.error('Error reading Excel file:', err);
    } finally {
      event.target.value = '';
    }
  };

  const handleConfirmModalImportar = async () => {
    try {
      setModalConfirmarImportarVisible(false);
      // console.log('listaClientesParaImportar:');
      // console.log(listaClientesParaImportar);
      // return;
      setProcessingVisible(true);
      const response = await crearClientesDesdeExcel({ listaClientes: listaClientesParaImportar });
      setProcessingVisible(false);
      if (response.error === false) {
        showToast(t("alert_se_importaron_correctamente"), "success", 3000);
        reset();
      }
      if (response.error === true) {
        showToast(response.message, "error", 3000);
      }
    } catch (error) {
      console.error('Error importing clients:', error);
      showToast(t("alert_no_se_pudo_importar_clientes") + "\n" + error.message, "error", 3000);
    } finally {
    }
  };

  const onClickExportar = () => {
    try {
      let link = "https://gestion.boltrack.net/assets/crearClienteTMS.xlsx";
      sharedExportarLink(link, "crearClienteTMS.xlsx");
    } catch (error) {
      console.error('Error exporting Excel:', error);
      showToast(t("alert_no_se_pudo_exportar_excel") + "\n" + error.message, "error", 3000);
    }
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="flex items-center justify-between py-4">
            <div>
              <div className="flex items-center gap-2">
                {/* <ArrowBack onClick={handleAtrasClick} /> */}
                <h2 className="text-xl font-bold text-gray-900">{t("label_gestionar_clientes")}</h2>
              </div>
              <p className="text-sm text-gray-500">{t("label_administra_la_lista_de_clientes")}</p>
            </div>
            <div className="flex flex-wrap items-center justify-end gap-2">
              {btnNuevo && (
                <button
                  type="button"
                  className={ESTILO_BOTON_LISTAR_NUEVO}
                  onClick={() => {
                    handleNuevoClick();
                  }}
                >
                  {t("label_nuevo")}
                </button>
              )}
              {btnImportar && (
                <button
                  type="button"
                  className="group relative bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md transition-all duration-300 transform hover:scale-110 hover:shadow-xl hover:shadow-green-500/50 flex items-center gap-2 overflow-hidden active:scale-95"
                  onClick={onClickImportar}
                >
                  <span className="relative z-10 flex items-center gap-2">
                    <Upload className="h-4 w-4 transition-all duration-300 group-hover:-translate-y-1 group-hover:rotate-12 group-hover:scale-110" />
                    <span className="font-medium transition-all duration-300 group-hover:tracking-wide">{t("label_importar")}</span>
                  </span>
                  <span className="absolute inset-0 bg-gradient-to-r from-green-400 via-green-500 to-green-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                  <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></span>
                  <span className="absolute -inset-1 bg-green-400 opacity-0 group-hover:opacity-20 blur-md transition-opacity duration-300"></span>
                </button>
              )}
              {btnExportar && (
                <button
                  type="button"
                  className="group relative bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md transition-all duration-300 transform hover:scale-110 hover:shadow-xl hover:shadow-blue-500/50 flex items-center gap-2 overflow-hidden active:scale-95"
                  onClick={onClickExportar}
                >
                  <span className="relative z-10 flex items-center gap-2">
                    <Download className="h-4 w-4 transition-all duration-300 group-hover:translate-y-1 group-hover:-rotate-12 group-hover:scale-110" />
                    <span className="font-medium transition-all duration-300 group-hover:tracking-wide">{t("label_exportar")}</span>
                  </span>
                  <span className="absolute inset-0 bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                  <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></span>
                  <span className="absolute -inset-1 bg-blue-400 opacity-0 group-hover:opacity-20 blur-md transition-opacity duration-300"></span>
                </button>
              )}
              <input
                type="file"
                className="hidden"
                id="importar_clientes"
                accept=".xlsx,.xls"
                onChange={handleFileChange}
              />
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                {t("label_estado")}
              </label>
              <Select options={SELECT_HABILITADO_DESHABILITADO} isSearchable='true'
                isClearable='true'
                value={habilitadoSelected}
                onChange={(event) => setHabilitadoSelected(event)}
                placeholder={t("placeholder_seleccione_estado")}
              />
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                &nbsp;
              </label>
              {btnBuscar && (
                <button
                  type="button"
                  className={ESTILO_BOTON_MODAL_ACEPTAR}
                  onClick={() => { reset(); }}
                >
                  {t("label_buscar")}
                </button>
              )}
            </div>
          </div>
          <br />
          {/* Grid Card */}
          <div className="bg-white border border-gray-200 rounded-lg p-2">
            <div className="min-h-[400px]">
              <div
                id="gridContainer"
                style={{
                  height: "100%",
                  width: "100%",
                }}
              />
            </div>
          </div>
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={() => { setModalConfirmarDeshabilitarVisible(false); }}
            onConfirm={handleConfirmModalDeshabilitar}
            message={sharedMensajeConfirmacion(t("alert_esta_de_deshabilitar"), elementoSelected?.descripcion)}
          />
          <ModalConfirmar
            isOpen={modalConfirmarHabilitarVisible}
            onCancel={() => { setModalConfirmarHabilitarVisible(false); }}
            onConfirm={handleConfirmHabilitarModal}
            message={sharedMensajeConfirmacion(t("alert_esta_de_habilitar"), elementoSelected?.descripcion)}
          />
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />

          <ModalConfirmar
            isOpen={modalConfirmarImportarVisible}
            onCancel={() => { setModalConfirmarImportarVisible(false); }}
            onConfirm={handleConfirmModalImportar}
            message={sharedMensajeConfirmacion(t("alert_esta_de_importar_clientes"), "")}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarCliente render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
